import { render, staticRenderFns } from "./AppealConfirmDialog.vue?vue&type=template&id=1f2ada1f&scoped=true"
import script from "./AppealConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AppealConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AppealConfirmDialog.vue?vue&type=style&index=0&id=1f2ada1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ada1f",
  null
  
)

export default component.exports